/** Strings owned by `src/features/profile/Consents.tsx` — the caller's own
 * consent answers, shown on `/profile`. */
export const consents = {
  title: 'Your consents',
  empty: 'No consent requests concern you.',
  collectiveNote:
    'A collective record on the department is in force; your personal answer has no effect while it stands.',
  table: {
    department: 'Department',
    status: 'Status',
    basis: 'Basis in force',
  },
  status: {
    pending: 'Awaiting your answer',
    granted: 'Granted',
    denied: 'Denied',
  },
  basis: {
    personal: 'Personal',
    collective: 'Collective',
  },
  actions: {
    grant: 'Grant',
    deny: 'Deny',
    withdraw: 'Withdraw',
  },
} as const;
